import '../App.css';
import Sidebar from '../components/Sidebar';
import '../styles/login.css'
import{withRouter} from "react-router-dom"
function Operaciones(props) {

  return (
    <div className="App">
      <Sidebar tipo="1"></Sidebar>
      <br/>
      <h1>Operacion</h1>
    </div>
  );
}

export default withRouter(Operaciones);